import React from "react";

export const Breadcrumbs = ({ crumbs }) => {
    return (
        <div className="blog-list">
            <span>Home {">"} Blog</span>
        </div>
    )
}
